import {loadAndShowModal} from "./modal";
import {initLookupComponent} from "./lookup";
import {generateBrowseReportLinks} from "./browse-the-report";
import {showToast} from "./toast";
import {trans} from "../i18n/i18n";
import {Toast} from "../consts/toast";

document.addEventListener('click', async function (event) {
    const button = event.target.closest('.js-sample-report-link');
    if (!button) return;

    event.preventDefault();

    await loadAndShowModal('report-modal', {
        size: 'modal-fullscreen',
        onLoad: () => initializeReportModal(button),
        onError: () => {
            showToast(trans("Failed to open sample report. Please try again later."), Toast.ERROR);
        }
    });
});

async function initializeReportModal() {
    try {
        const decoderElement = document.getElementById("vin-decoder-sample");

        if (!decoderElement) {
            throw new Error("#vin-decoder-sample element not found");
        }

        const rawData = decoderElement.dataset.fullReportData;
        const details = JSON.parse(rawData);

        initLookupComponent(details);
        generateBrowseReportLinks();
    } catch (error) {
        console.error("Error loading details for report modal:", error);
    }
}
